import React from 'react';
import {
  Label,
  LabelWrapper,
  TextArea,
  TextMiddleArea,
  TextTopArea,
  Title,
  Wrapper,
} from '@/components/organisms/loanListItem/LoanListItem.styled';
import {AvatarCircle, Subtitle} from '@/components/atoms';
import {ILoanItem} from '@/types';
import dynamic from 'next/dynamic';

const Chip = dynamic(() => import('@/components/atoms/Chip').then((module) => module.Chip), {
  ssr: false,
});

const LoanListItem = (props: ILoanItem) => {
  const {
    compNm,
    loanName,
    support,
    creditLineText,
    advtText,
    licenseNo1,
    compLogoImgUrl,
    interestMinRate,
    interestMaxRate,
    categoryCd,
    onClick,
    lcsBanner,
  } = props;
  const DynamicChip = Chip as React.ComponentType<any>;

  const getRate = () => {
    if (categoryCd === 'C001' && interestMinRate === interestMaxRate) {
      return `${interestMaxRate}%`;
    } else {
      return `${interestMinRate}~${interestMaxRate}%`;
    }
  }

  return (
    <>
      <Wrapper onClick={onClick}>
        <AvatarCircle src={compLogoImgUrl}/>
        <TextArea className="text-area">
          <TextTopArea>
            <Title>
              <Subtitle level={4} color="gray-800">
                {compNm}
              </Subtitle>
              <Subtitle level={6}>{loanName}</Subtitle>
            </Title>
            {support > 0 && <DynamicChip>{`이자 ${support}% 지원`}</DynamicChip>}
          </TextTopArea>
          <TextMiddleArea>
            {interestMinRate && interestMaxRate && (
              <Label>
                <LabelWrapper>
                  <Subtitle level={6}>{categoryCd === 'C001' ? '캐시백' : '금리'}</Subtitle>
                </LabelWrapper>
                <Subtitle level={1} color="gray-800">
                  {getRate()}
                </Subtitle>
              </Label>
            )}
            {creditLineText && (
              <Label>
                <LabelWrapper>
                  <Subtitle level={6}>최대</Subtitle>
                </LabelWrapper>
                <Subtitle level={1} color="gray-800" whiteSpaceWrap>
                  {creditLineText}
                </Subtitle>
              </Label>
            )}
          </TextMiddleArea>
          {advtText && (
            <Subtitle level={6} color="primary-100" whiteSpaceWrap>
              {advtText}
            </Subtitle>
          )}
          {licenseNo1 && (
            <Subtitle level={9} color="gray-500" whiteSpaceWrap>
              {licenseNo1}
            </Subtitle>
          )}
        </TextArea>
      </Wrapper>
    </>
  );
};

export default React.memo(LoanListItem);
